module.exports = __webpack_public_path__ + "img/potencia_a_red.73f956a7.svg";